import * as type from "../../types/API/userTypes";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const usersReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_USERS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.GET_USERS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addUserReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_USER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_USER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_USER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editUserReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_USER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_USER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_USER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteUserReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_USER:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_USER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateUserReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_USER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UPDATE_USER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_USER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateProfileLogoReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_PROFILE_LOGO:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case type.UPDATE_PROFILE_LOGO_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_PROFILE_LOGO_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateSignatureReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_SIGNATURE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case type.UPDATE_SIGNATURE_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_SIGNATURE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getPartialUserReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_PARTIAL_USER:
      return {
        ...state,
        loading: true,
      };
    case type.GET_PARTIAL_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.GET_PARTIAL_USER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getCompaniesReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_COMPANIES:
      return {
        ...state,
        loading: true,
      };
    case type.GET_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData?.users,
      };
    case type.GET_COMPANIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteCompaniesDataReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_COMPANIES_DATA:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_COMPANIES_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData?.message,
      };
    case type.DELETE_COMPANIES_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
